export const DEFAULT_TRANSLATION = 'quran-in-arabic';
